var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtcLgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 15,
    fill: "#593913"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.0634 19.5284C35.9198 15.6028 32.7327 14.0587 28.6365 13.3871L28.9414 7.97871L25.7517 7.74728L25.4551 13.0132C24.6165 12.9522 23.7586 12.907 22.9059 12.8627L23.2052 7.56179L20.0175 7.33002L19.7116 12.7369C19.0204 12.7013 18.3413 12.6653 17.6801 12.6176L17.6807 12.6007L13.2816 12.2792L13.0843 15.7954C13.0843 15.7954 15.4422 15.9204 15.4006 15.9621C16.6923 16.0563 17.0693 16.8612 17.1542 17.5381L16.8071 23.6995C16.8961 23.7063 17.0122 23.7186 17.143 23.7471C17.0366 23.7394 16.9232 23.7306 16.806 23.7232L16.3185 32.3547C16.2384 32.7701 15.9617 33.4221 15.0589 33.358C15.0977 33.3982 12.7404 33.1889 12.7404 33.1889L11.8849 37.0745L16.0358 37.3762C16.8082 37.4334 17.5675 37.5022 18.3135 37.5611L18.0066 43.0312L21.1928 43.2633L21.4976 37.851C22.3715 37.9333 23.2175 38.002 24.0443 38.0614L23.7392 43.4485L26.929 43.6799L27.2376 38.2196C32.618 38.2919 36.4497 37.1706 37.2085 32.0067C37.8206 27.849 36.0186 25.843 33.0174 24.8673C34.9216 24.0297 36.1731 22.4011 36.0634 19.5284ZM30.9416 30.9002C30.7128 34.9882 23.9576 34.0303 21.7958 33.8752L22.2052 26.6277C24.3674 26.7855 31.182 26.6365 30.9416 30.9002ZM30.0344 20.567C29.8239 24.2859 24.1928 23.4408 22.3922 23.31L22.7629 16.737C24.5635 16.8678 30.2525 16.6882 30.0344 20.567Z",
    fill: "#F7931A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtcLgIcon);
export default __webpack_public_path__ + "static/media/btc-lg-icon.e47d849f6fd13fe18c59ca4c3e0c27a9.svg";
export { ForwardRef as ReactComponent };